import React from 'react';
import ic_color from './ic_color.svg';
import ic_sort from './ic_sort.svg';
import ic_noti from './ic_noti.svg';
import ic_layout from './ic_layout.svg';
import ic_reorder from './ic_reorder.svg';
import ic_reorder_working from './ic_reorder-working.svg';
import styled from 'styled-components';
import { get } from 'lodash';
import { Badge } from 'antd';

export enum HOME_CONFIGURE_BUTTON_TYPE {
  COLOR = 'color',
  SORT_STAFF_AVAILABLE = 'sort_staff_available',
  REORDER_CLOCK_IN = 'reorder_clock_in',
  HOME_LAYOUT = 'home_layout',
  NOTIFICATION = 'notification',
  REORDER_WORKING_STAFF = 'reorder_working_staff',
}

const configs = {
  [HOME_CONFIGURE_BUTTON_TYPE.COLOR]: {
    icon: ic_color,
    label: 'Color',
  },
  [HOME_CONFIGURE_BUTTON_TYPE.SORT_STAFF_AVAILABLE]: {
    icon: ic_sort,
    label: 'Sort staff available',
  },
  [HOME_CONFIGURE_BUTTON_TYPE.REORDER_CLOCK_IN]: {
    icon: ic_reorder,
    label: 'Reorder clock in',
  },
  [HOME_CONFIGURE_BUTTON_TYPE.HOME_LAYOUT]: {
    icon: ic_layout,
    label: 'Home layout',
  },
  [HOME_CONFIGURE_BUTTON_TYPE.NOTIFICATION]: {
    icon: ic_noti,
    label: 'Notification',
  },
  [HOME_CONFIGURE_BUTTON_TYPE.REORDER_WORKING_STAFF]: {
    icon: ic_reorder_working,
    label: 'Reorder working staff',
  },
};
type Props = {
  type: HOME_CONFIGURE_BUTTON_TYPE;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  count?: number;
}
const HomeConfigureButton = ({ type, onClick, count }: Props) => {
  const config = get(configs, type, null);
  if (!config) return null;
  return (
    <ButtonIcon type='button' onClick={onClick}>
      {count ? (
        <Badge count={count} showZero={false} size='default' offset={[-4, 8]}>
          <img src={config.icon} alt={config.label} />
        </Badge>
      ) : <img src={config.icon} alt={config.label} />}

    </ButtonIcon>
  );
};

export default HomeConfigureButton;

const ButtonIcon = styled.button`
display: flex;
width: 56px;
height: 56px;
justify-content: center;
align-items: center;
gap: 10px;
border-radius: 4px;
background: #FCFCFD;
position: relative;
box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.40), 0 4px 8px -3px rgba(45, 35, 66, 0.30), 0 -3px 0 0 #D6D6E7 inset;
img {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
}
`;
